import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { TypographyAppearance, useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { Check } from '@bcp-nextgen-dx-component-factory/accolade-design-system/dist/assets/MBCP/icons';
import { rem } from '@helpers';
import { useSeparateLastWordFromPhrase } from '@hooks';
import { useNavigation } from '@navigation';
import { useSelectedSolution } from '@store';
import { useMemo } from 'react';

interface MembershipCompletionEnterpriseSolutionResources {
	statusTitle: string;
	statusDescription: string;
	selectSolutionIziBizi: string;
}

interface MembershipCompletionEnterpriseSolutionHelperOutput {
	resources: MembershipCompletionEnterpriseSolutionResources;
	icon: React.ReactNode;
	iconBgColor: string;
	appearanceSolutionName: TypographyAppearance | undefined;
	solutionName: string;
	premiumSolution: string;
	defaultSolutionName: string;
	solutionNameWithoutLastWord: string;
	solutionNameLastWord: string;
	onHandlePress: () => void;
}

export const useMembershipCompletionEnterpriseSolutionHelper =
	(): MembershipCompletionEnterpriseSolutionHelperOutput => {
		const t = useTranslation();
		const { navigate } = useNavigation();
		const { palette } = useTheme();

		const resources = useMemo((): MembershipCompletionEnterpriseSolutionResources => {
			return {
				statusTitle: t(
					'placeholders.subscriptionConclusion.enterpriseSolution.statusTitle.successfulSubscription'
				),
				statusDescription: t(
					'placeholders.subscriptionConclusion.enterpriseSolution.statusDescription.successfulSubscription'
				),
				selectSolutionIziBizi: t('placeholders.subscriptionConclusion.selectPlanIziBizi'),
			};
		}, [t]);

		const icon = <Check fill={palette.global.ui18} width={rem(36)} height={rem(36)} />;
		const iconBgColor = palette.global.ui21;

		const appearanceSolutionName = 'subtitle-100-04';

		const selectedSolution = useSelectedSolution();

		const solutionName = selectedSolution?.name as string;

		const defaultSolutionName = t('placeholders.enterpriseSolution.card.subtitle', {
			planName: selectedSolution?.name,
		});
		const premiumSolution = t('mbcp.enterprise.solutions[1].name');

		const { phraseWithoutLastWord: solutionNameWithoutLastWord, lastWord: solutionNameLastWord } =
			useSeparateLastWordFromPhrase(defaultSolutionName);

		const onHandlePress = () => {
			navigate('subscriptionSelectPlan');
		};

		return {
			resources,
			icon,
			iconBgColor,
			appearanceSolutionName,
			solutionName,
			solutionNameWithoutLastWord,
			solutionNameLastWord,
			premiumSolution,
			defaultSolutionName,
			onHandlePress,
		};
	};
